export const DRAFT = 'DRAFT';
export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const BUDGET_EVENT_NAME_LENGTH = 500;

const ITEM_GROUP_FIELD = 'ITEM_GROUP_FIELD';
const ENCOUNTER_ITEM_GROUP_FIELD = 'ENCOUNTER_ITEM_GROUP_FIELD';
const UNEXPECTED_ITEM_GROUP_FIELD = 'UNEXPECTED_ITEM_GROUP_FIELD';
const SITUATIONAL_ITEM_GROUP_FIELD = 'SITUATIONAL_ITEM_GROUP_FIELD';

export const FIELD_EVENT_TYPES = [
  ITEM_GROUP_FIELD,
  ENCOUNTER_ITEM_GROUP_FIELD,
  UNEXPECTED_ITEM_GROUP_FIELD,
  SITUATIONAL_ITEM_GROUP_FIELD
];

export const eventTypes = {
  ENCOUNTER: { BudgetRowType: 'ENCOUNTER' },
  UNEXPECTED_ENCOUNTER: { BudgetRowType: 'UNEXPECTED_ENCOUNTER' },
  SITUATIONAL_ENCOUNTER: { BudgetRowType: 'SITUATIONAL_ENCOUNTER' },

  ENCOUNTER_ITEM_GROUP: { BudgetRowType: 'ENCOUNTER_ITEM_GROUP' },
  UNEXPECTED_ITEM_GROUP: { BudgetRowType: 'UNEXPECTED_ITEM_GROUP' },
  SITUATIONAL_ITEM_GROUP: { BudgetRowType: 'SITUATIONAL_ITEM_GROUP' },

  ENCOUNTER_ITEM_GROUP_FIELD: { BudgetRowType: ENCOUNTER_ITEM_GROUP_FIELD },
  UNEXPECTED_ITEM_GROUP_FIELD: { BudgetRowType: UNEXPECTED_ITEM_GROUP_FIELD },
  SITUATIONAL_ITEM_GROUP_FIELD: { BudgetRowType: SITUATIONAL_ITEM_GROUP_FIELD },

  ITEM_GROUP_GENERAL: { BudgetRowType: 'ITEM_GROUP_GENERAL' },
  ITEM_GROUP_FIELD: { BudgetRowType: ITEM_GROUP_FIELD },

  ITEM_GROUP_PATIENT_STIPEND: { BudgetRowType: 'ITEM_GROUP_PATIENT_STIPEND' },

  EXPENSE_FIXED: { BudgetRowType: 'EXPENSE_FIXED' },

  STATUS_CHANGE: { BudgetRowType: 'STATUS_CHANGE' },

  RATIO_STATUS_CHANGE: { BudgetRowType: 'RATIO_STATUS_CHANGE' },

  ENCOUNTER_STATUS_CHANGE: { BudgetRowType: 'ENCOUNTER_STATUS_CHANGE' },
  PATIENT_REIMBURSEMENT: { BudgetRowType: 'PATIENT_REIMBURSEMENT' }
};

export const eventTypeLabel = {
  EXPENSE_FIXED: 'Expense - Fixed',
  EXPENSE_VARIABLE: 'Expense - Variable',
  ENCOUNTER: 'Encounter',
  UNEXPECTED_ENCOUNTER: 'Encounter',
  SITUATIONAL_ENCOUNTER: 'Encounter',
  ENCOUNTER_ITEM_GROUP: 'Encounter - Item Group',
  SITUATIONAL_ITEM_GROUP: 'Encounter - Item Group',
  STATUS_CHANGE: 'Status Change',
  RATIO_STATUS_CHANGE: 'Status Change with Ratio',
  PATIENT_REIMBURSEMENT: 'Patient Reimbursement',
  ITEM_GROUP_PATIENT_STIPEND: 'Patient Stipend',
  ITEM_GROUP_GENERAL: 'Item Group',
  ITEM_GROUP_FIELD: 'Item Group - Field',
  ENCOUNTER_ITEM_GROUP_FIELD: 'Encounter - Item Group - Field',
  SITUATIONAL_ITEM_GROUP_FIELD: 'Encounter - Item Group - Field',
  UNEXPECTED_ITEM_GROUP_FIELD: 'Encounter - Item Group - Field',
  UNEXPECTED_ITEM_GROUP: 'Encounter - Item Group',
  ENCOUNTER_STATUS_CHANGE: 'Encounter - Status Change'
};
